import {
  Person24Regular,
  ContactCard24Regular,
  BookContacts24Regular,
  Person20Regular,
  ContactCard20Regular,
  BookContacts20Regular,
} from "@fluentui/react-icons";

export const ENTITY_VACANCY = "Vacancy";
export const ENTITY_CANDIDATE = "Candidate";
export const ENTITY_RELATION = "Relation";
export const ENTITY_RELATION_CONTACT = "RelationContact";
export const ENTITY_CONSULTANT = "Consultant";
export const ENTITY_TASK = "Task";
export const ENTITY_ATTACHED_DOCUMENT = "AttachedDocument";
export const ENTITY_CALENDAR_ITEM = "CalendarItem";

export const ENTITY_MAP = {
  [ENTITY_VACANCY]: 1,
  [ENTITY_CANDIDATE]: 2,
  [ENTITY_RELATION]: 3,
  [ENTITY_RELATION_CONTACT]: 4,
  [ENTITY_CONSULTANT]: 14,
  [ENTITY_TASK]: 28,
  [ENTITY_ATTACHED_DOCUMENT]: 36,
  [ENTITY_CALENDAR_ITEM]: 46,
};

export const NOTICE_UID_FIELD_BY_ENTITY_ID: Record<number, string> = {
  [ENTITY_MAP[ENTITY_VACANCY]]: "vacancyUid",
  [ENTITY_MAP[ENTITY_CANDIDATE]]: "candidateUid",
  [ENTITY_MAP[ENTITY_RELATION]]: "relationUid",
  [ENTITY_MAP[ENTITY_RELATION_CONTACT]]: "relationContactUid",
};

export const ENTITY_ICONS = {
  [ENTITY_CONSULTANT]: {
    20: Person20Regular,
    24: Person24Regular,
  },
  [ENTITY_CANDIDATE]: {
    20: Person20Regular,
    24: Person24Regular,
  },
  [ENTITY_RELATION]: {
    20: ContactCard20Regular,
    24: ContactCard24Regular,
  },
  [ENTITY_RELATION_CONTACT]: {
    20: BookContacts20Regular,
    24: BookContacts24Regular,
  },
};

export const ALLOWED_CONTENT_TYPES = [
  "application/pdf", 
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/msword",
];

export const MODULAR_HTML = "modular.html#";
